module.exports = __webpack_public_path__ + "static/media/switch-off.e88dd384.svg";